import IcStarLight from 'assets/images/ic-star-light.svg'
import { List } from 'components/order/list'

export const ProductReviewDetail = (props) => {
    const { query, onChangeTab, productDetailStatistic, skinType } = props

    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex flex-row items-center justify-between bg-blue-2 p-8 rounded'}>
                <div className={'flex flex-row items-center space-x-4'}>
                    <img
                        alt={productDetailStatistic?.image?.alt_text}
                        src={productDetailStatistic?.image?.url}
                        className={'w-24 h-24'}
                    />
                    <p className={'text-lg text-gray-95 w-2/3'}>{productDetailStatistic?.name}</p>
                </div>
                <div className={'flex flex-row items-center space-x-4'}>
                    <div
                        className={
                            'flex flex-col items-center border border-gray-95 rounded bg-white p-4 text-gray-95 space-y-1'
                        }
                    >
                        <p className={'font-bold text-sm'}>Total Review</p>
                        <p className={'text-xl'}>{productDetailStatistic?.total_review}</p>
                    </div>
                    <div
                        className={
                            'flex flex-col items-center border border-gray-95 rounded bg-white p-4 text-gray-95 space-y-1'
                        }
                    >
                        <p className={'font-bold text-sm'}>Total Rating</p>
                        <div className={'flex space-x-1 items-center'}>
                            <img alt={'star'} src={IcStarLight} className={'w-6 h-6'} />
                            <p className={'text-xl'}>{productDetailStatistic?.total_rating}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'grid grid-cols-5 gap-4 mt-8'}>
                <div className={'space-y-2 h-full font-regular bg-blue-10 overflow-hidden'}>
                    <div className={'flex justify-center py-3 bg-blue-90 rounded-t-lg'}>
                        <p className={'font-semibold text-white'}>Skin Type</p>
                    </div>
                    <div className={'space-y-1 text-gray-95'}>
                        {skinType?.length > 0 &&
                            skinType.map((dataSelect, index) => (
                                <div
                                    key={index}
                                    onClick={() => onChangeTab({ skin_type: dataSelect?.query })}
                                    className={`flex justify-between p-3 hover:bg-blue-2 cursor-pointer ${query?.skin_type === dataSelect.query && 'bg-blue-5'}`}
                                >
                                    <p className={'font-semibold'}>{dataSelect.name}</p>
                                    <p>{dataSelect?.count}</p>
                                </div>
                            ))}
                    </div>
                </div>
                <div className={'col-span-4'}>
                    <List {...props} />
                </div>
            </div>
        </div>
    )
}
